export const mbProductLine = {
  pdpProductLine: {
    orderNumber: 'Catalog no.',
    productName: 'Product name',
    size: 'Size',
    applications: 'Applications',
    quantity: 'Quantity',
    listPrice: 'List price',
    viewComponents: 'View components',
    matchingComponents: 'Matching components',
    orderNoWasCopiedToYourClipboard: 'Catalog no. was copied to your clipboard',
    otherSizes: 'Other sizes',
    userManual: 'User manual',
    userManuals: 'User manuals'
  },
  cartProductLine: {
    size: 'Size',
    clone: 'Clone',
    price: 'Price'
  },
  emptyCart: {
    carEmptyMessage: 'Your shopping cart is currently empty. Please add some great products.',
    browseProducts: 'Browse products'
  },
  pdpWishList: {
    addToWishlist: 'Add to favorites',
    removeFromWishlist: 'Remove from favorites',
    signInToWishlist: 'Sign in to add to favorites'
  }
}
